<!-- =========================================================================================
File Name: TheNavbar.vue
Description: Navbar component
Component Name: TheNavbar
----------------------------------------------------------------------------------------
Item Name: Vuesax Admin - VueJS Dashboard Admin Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="relative">
        <div class="vx-navbar-wrapper">
            <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">

                <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon>

                <template v-if="breakpoint != 'md'">
                    <ul class="vx-navbar__starred-pages">
                        <draggable v-model="starredPagesLimited" :group="{name: 'pinList'}" class="flex cursor-move">
                            <li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">
                                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                                </vx-tooltip>
                            </li>
                        </draggable>
                    </ul>

                    <div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
                        <vs-dropdown vs-custom-content vs-trigger-click>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>
                            <vs-dropdown-menu>
                                <ul class="vx-navbar__starred-pages-more--list">
                                    <draggable v-model="starredPagesMore" :group="{name: 'pinList'}" class="cursor-move">
                                        <li class="starred-page--more flex items-center cursor-pointer" v-for="page in starredPagesMore" :key="page.url" @click="$router.push(page.url)">
                                            <feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1" :icon="page.labelIcon"></feather-icon>
                                            <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                                        </li>
                                    </draggable>
                                </ul>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                </template>

                <div class="the-navbar__user-meta flex items-center mr-2">
                    <div class="text-left leading-tight hidden sm:block">
                        <p class="font-semibold"> {{ $t("salutation")}}, {{ user_displayName }}</p>
                    </div>
                </div>

                <vs-spacer></vs-spacer>

                <div class="the-navbar__user-meta flex items-center">
                    <div class="text-right leading-tight hidden sm:block">

                        <div class="flex items-center nabarx"> 
                            <vs-navbar-item index="0">  

                                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                                    <span class="cursor-pointer flex i18n-locale"><img class="h-5 w-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span></span>            
                                    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
                                        <vs-dropdown-item @click="updateLocale('en')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t("tr_to_en")}}</vs-dropdown-item>
                                        <vs-dropdown-item @click="updateLocale('fr')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t("tr_to_fr")}}</vs-dropdown-item>
                                        <vs-dropdown-item @click="updateLocale('de')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t("tr_to_de")}}</vs-dropdown-item>
                                        <vs-dropdown-item @click="updateLocale('pt')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t("tr_to_pt")}}</vs-dropdown-item>
                                        <vs-dropdown-item @click="updateLocale('es')"><img class="h-5 w-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t("tr_to_es")}}</vs-dropdown-item>
                                    </vs-dropdown-menu>
                                </vs-dropdown>

                            </vs-navbar-item>

                            <vs-navbar-item index="1" class="ml-5 mr-5">
                                <v-select
                                    :style="'min-width:' +select_width+'px'"
                                    v-if="spasTemp.length > 0 && ['horarios', 'marcar', 'marcarOutras', 'faturacao'].indexOf($route.name) !== -1"
                                    label="label"
                                    v-model="spaTempval"
                                    @change="updateSpaOnScheduler"
                                    :reduce="item => item.spa_id" 
                                    :options="spasTemp" 
                                    :clearable="false" 
                                >
                                    <span slot="no-options">{{$t('vSelectNoResults')}}</span>
                                </v-select>
                            </vs-navbar-item>

                            <vs-navbar-item index="2">
                                <vs-button @click="logout()" type="flat" icon-pack="feather" icon="icon-log-out" />
                            </vs-navbar-item>

                        </div>

                    </div>
                </div>

            </vs-navbar>
        </div>
    </div>
</template>

<script>
    import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import draggable from 'vuedraggable'
    import axios from 'axios';  

    import themeConfig from '@/../themeConfig.js';

    export default {
        name: "the-navbar",
        props: {
            navbarColor: {
                type: String,
                default: "#fff",
            },
            listUpdatedSpas: '',
            SpaListNavbar: Array,
            spaTemp: null,
        },

        data() {
            return {
                navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
                searchQuery: '',
                showFullSearch: false,
                settings: { 
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },

                autoFocusSearch: false,
                showBookmarkPagesDropdown: false,
                spasTemp: [],
                spaTempval: '',
                hotelTempval: '',
                numSpaByUser: 0,
                select_width: 400, //para colocar o select dos spas com tamanho dinamico, 400 é valor por default
            }
        },

        created() {
            this.spasvgbyUser();
            this.$store.dispatch('getHoteis');    
            this.$store.dispatch('getSpas');
        },

        computed: {
            sidebarWidth() {
                return this.$store.state.sidebarWidth;
            },
            breakpoint() {
                return this.$store.state.breakpoint;
            },

            classObj() {
                if (this.sidebarWidth == "default") return "navbar-default"
                    else if (this.sidebarWidth == "reduced") return "navbar-reduced"
                        else if (this.sidebarWidth) return "navbar-full"
            },

            getCurrentLocaleData() {
                const locale = this.$i18n.locale;
                if (locale == "en") return { flag: "us", lang: this.$i18n.messages['en'].tr_to_en }
                else if (locale == "pt") return { flag: "br", lang: this.$i18n.messages['pt'].tr_to_pt }
                else if (locale == "fr") return { flag: "fr", lang: this.$i18n.messages['fr'].tr_to_fr }
                else if (locale == "de") return { flag: "de", lang: this.$i18n.messages['de'].tr_to_de }
                else if (locale == "es") return { flag: "es", lang: this.$i18n.messages['es'].tr_to_es }
            },

            data() {
                return this.$store.state.navbarSearchAndPinList;
            },

            starredPages() {
                return this.$store.state.starredPages;
            },

            starredPagesLimited: {
                get() 
                {
                    return this.starredPages.slice(0, 10);
                },
                set(list) 
                {
                    this.$store.dispatch('arrangeStarredPagesLimited', list);
                }
            },

            starredPagesMore: {
                get() 
                {
                    return this.starredPages.slice(10);
                },
                set(list) 
                {
                    this.$store.dispatch('arrangeStarredPagesMore', list);
                }
            },

            user_displayName() {
                let tempUser =  JSON.parse(window.localStorage.getItem('userSession'));
                return tempUser.name;
            },

            activeUserImg() {
                if(localStorage.getItem('userInfo') !== null)
                    return JSON.parse(localStorage.getItem('userInfo')).photoURL || this.$store.state.AppActiveUser.img;
                return 'https://camo.envatousercontent.com/9a7afb851feac48bc7f4e15aeed509cd8d40c5c6/68747470733a2f2f692e696d6775722e636f6d2f624f4c56536d4b2e706e67';
            },
        },

        methods: {
            updateLocale(locale) {
                this.$i18n.locale = locale;
            },       

            showSidebar() {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
            },

            selected(item) {
                this.$router.push(item.url)
                this.showFullSearch = false;
            },

            actionClicked(item) {
                this.$store.dispatch('updateStarredPage', { index: item.index, val: !item.highlightAction });
            },

            showNavbarSearch() {
                this.showFullSearch = true;
            },

            showSearchbar() {
                this.showFullSearch = true;
            },

            elapsedTime(startTime) {
                let x = new Date(startTime);
                let now = new Date();
                let timeDiff = now - x;
                timeDiff /= 1000;

                let seconds = Math.round(timeDiff);
                timeDiff = Math.floor(timeDiff / 60);

                let minutes = Math.round(timeDiff % 60);
                timeDiff = Math.floor(timeDiff / 60);

                let hours = Math.round(timeDiff % 24);
                timeDiff = Math.floor(timeDiff / 24);

                let days = Math.round(timeDiff % 365);
                timeDiff = Math.floor(timeDiff / 365);

                let years = timeDiff;

                if (years > 0) {
                    return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
                } else if (days > 0) {
                    return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
                } else if (hours > 0) {
                    return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
                } else if (minutes > 0) {
                    return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
                } else if (seconds > 0) {
                    return seconds + (seconds > 1 ? `${seconds} sec ago` : 'just now');
                }

                return 'Just Now';
            },

            outside: function() {
                this.showBookmarkPagesDropdown = false
            },

            logout: function(){
                window.localStorage.removeItem('usertoken');    
                window.localStorage.removeItem('userSession');    

                window.localStorage.clear();

                this.$store.dispatch('removeSelectedSpa');

                this.$router.push('/login');  
            },

            updateSpaOnScheduler(){
                this.$emit('spaChanged',this.spaTempval);

                this.$emit('hotelChanged',this.hotelTempval);
            },

            spasvgbyUser() { 
                let session = JSON.parse(window.localStorage.getItem('userSession'));  

                let that = this;
                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/spa/spas/byTherapist/' + session.id + '?token='+window.localStorage.getItem('usertoken'),
                }).then(function (res) { 
                    if(res.status == 200){
                        let count = 0;
                        that.spasTemp = res.data.map(function(item, index){
                            item.label = item.name + ' | ' + item.hvg_nome;
                            count = (count < item.label.length) ? item.label.length : count; //para colocar o select dos spas com tamanho dinamico
                            return item;
                        });

                        that.select_width = count*8.2; //para colocar o select dos spas com tamanho dinamico

                        that.$emit('spaListSelect', that.spasTemp);

                        that.spaTempval = res.data.length == 0 ? 0 : res.data[0].spa_id;

                        that.hotelTempval = res.data.length == 0 ? 0 : res.data[0].hvg_id;

                    }                                      
                }).catch( function (err) {
                    console.log(err);
                })
            },
        },

        directives: {
            'click-outside': {
                bind: function(el, binding) {
                    const bubble = binding.modifiers.bubble
                    const handler = (e) => {
                        if (bubble || (!el.contains(e.target) && el !== e.target)) {
                            binding.value(e)
                        }
                    }
                    el.__vueClickOutside__ = handler
                    document.addEventListener('click', handler)
                },

                unbind: function(el) {
                    document.removeEventListener('click', el.__vueClickOutside__)
                    el.__vueClickOutside__ = null
                }

            }
        },
        components: {
            VxAutoSuggest,
            VuePerfectScrollbar,
            draggable
        },

        watch: {
            '$route'() {
                if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
            },

            user_displayName(new_val, old_val) {
                if( new_val !== '' ){
                    this.spasvg();
                }
            },

            spaTempval(new_val, old_val) {
                this.$store.dispatch('modifySelectedSpa',new_val);

                this.hotelTempval = this.spasTemp.length == 0 ? null : this.spasTemp.find(el => el.spa_id == new_val).hvg_id;

                this.$emit('loadScheduler',new_val);

                this.$emit('loadInitialHotel',this.hotelTempval);
            },

            listUpdatedSpas(new_val, old_val){

                if(new_val !== '' && new_val !== old_val)
                {
                    this.spasTemp = new_val;

                    this.spaTempval = new_val[0].spa_id; 

                    this.hotelTempval = new_val[0].hvg_id;
                }
            },

            SpaListNavbar(new_val, old_val){
                this.spasTemp = new_val;
            },

            spaTemp(new_val, old_val){
                this.spasvgbyUser();
            },
        },

    }
</script>

<style>
    .vx-navbar-wrapper .vs__dropdown-menu{
        width: auto;
    }
</style>